<template>
  <div class="panel panel-default panel-top-bordered">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-18">
          <h5>
            Top 50 this month
          </h5>
        </div>

        <div class="col-xs-6">
          <SelectWidget
              style="margin-top: 4px;"
              v-model="contentType"
              class="form-control input-sm"
              :options="[{value: 'articles_and_topics', label: 'Articles and topics'}, {value: 'events', label: 'Events'}, {value: 'files', label: 'Files'}, {value: 'jobs', label: 'Jobs'}, {value: 'registrations', label: 'Registrations'}]"
          />
        </div>
      </div>
    </div>

    <div class="panel-body text-center">
      <canvas ref="chart" width="120" height="200"/>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import http from '@/http'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components:{SelectWidget},

  props: {
    portalCompany: {
      required: true,
    },

    filters: {
      required: true,
    }
  },

  data() {
    return {
      result: null,
      chartData: null,

      contentType: 'articles_and_topics',

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    filters() {
      this.load()
    },

    contentType(){
      this.draw()
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/portal-companies/' + this.portalCompany.id + '/statistics/total-content/' + this.filters.from +'/' + this.filters.to).then(response => {
        this.result = response.data.data

        this.loading = false

        this.draw()
      })
    },

    draw() {
      if (this.chartData) {
        this.chartData.destroy()
      }

      this.$nextTick(() => {
        this.chartData = new Chart(this.$refs.chart, {
          type: 'horizontalBar',

          data: {
            labels: this.result.attributes.value[this.contentType].map(row => row.rank + '. ' + row.title),

            datasets: [
              {
                label: 'My content',
                data: this.result.attributes.value[this.contentType].map(row => row.is_own ? row.count : 0),
                backgroundColor: '#fd612c',
                borderColor: '#fd612c',
                color: '#fd612c',
              },

              {
                label: 'Other content',
                data: this.result.attributes.value[this.contentType].map(row => row.is_own ? 0 : row.count),
                backgroundColor: '#cccccc',
                borderColor: '#cccccc',
                color: '#cccccc',
              },
            ]
          },

          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  precision: 0,
                  beginAtZero: true
                }
              }]
            },

            plugins: {
              datalabels: {
                display: false
              }
            },

            tooltips: {
              callbacks: {
                label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + d.datasets[t.datasetIndex].data[t.index]
              }
            },
          }
        })
      })
    },
  }
}
</script>
